export default {
    title: "Team leader",
    icon: "mdi-account-group",
    capability: "section.team-leader",
    groups: ["Team leader", "Amministrazione", "Admin"],
    submenu: [
        {
            title: "Reparti",
            route: { name: "team-leader-reparto" },
            groups: ["Team leader", "Amministrazione", "Admin"],
        },
        { title: "Miglioramenti", route: { name: "team-leader-miglioramenti" }, groups: ["Team leader", "Amministrazione", "Admin"] },
        { title: "Azienda", route: { name: "team-leader-azienda" }, groups: ["Admin"] },
    ],
};
